/*  ==========================================================================
    ROOMS LIST VIEW
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';
import objectFitImages from 'object-fit-images';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';
import {slick_nextArrowV2, slick_prevArrowV2} from "../../globals/variables";

/*
 * MODULE
 */

// filter function
function filter($filter,container,cat) {

    // show desired rooms
    $(container).find('.bn-room-box').removeClass('bn-room-box--act');
    $(container).find('.bn-room-box--'+cat).addClass('bn-room-box--act');

    // reposition rooms which are active
    $($(container).find('.bn-room-box--act').get().reverse()).each(function() {
        $(this).prependTo(container);
    });

}

// hook function
function funcHook(container,data) {

    // calculate min price and add it to record
    utils.ehotelierPrices.initEhotelierRoomMinPrice(data);

}

// custom function
function funcCustom(container,data) {

    // object fit fix for older browsers (especially ie11)
    let images = $(container).find('img');
    objectFitImages(images, {
        watchMQ: true
    });

    // init slider
    let $sliderContainer = $(container),
        sliderOverrides = {
            dots: true,
            appendDots: $(container).parent().find('.bn-rooms-teaser__dots'),
            equalHeight: true,
            nextArrow: vars.slick_nextArrowV2,
            pauseOnHover: true,
            prevArrow: vars.slick_prevArrowV2,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        equalHeight: false,
                        slidesToShow: 1
                    }
                },
            ],
            slidesToShow: 1
        };

    utils.slickCarousel.initSingleSlider($sliderContainer,sliderOverrides);

    // add param skd-search-id to booking link
    $(container).find('.JS-booking-button').each(function (event) {
        const $button = $(this),
            referrerData = window.BN.getMarketingSources();

        let oldUrl = $button.attr('href');
        if (!oldUrl.includes('skd-search-id')) {
            let newUrl = oldUrl + '&skd-search-id=' + referrerData.partner;
            $button.attr('href', newUrl);
        }
    });
}

// initialization
export function initRoomsTeaser($element) {
    let container = $element.find('.eh-service');

    // config
    let config = {
        addParams: {},
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'room',
        subtype: 'list-view'
    };

    // ehotelier service initialization (if element is in view)
    $element.one('inview', function() {
        utils.ehotelierLoader.initEhotlierService(config);
    });
}


// WEBPACK FOOTER //
// ./source/js/modules/lib/rooms-teaser.js